import { Head, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import LogForm from "./_form"

interface Customer {
  id: number
  display_name: string
}

interface Option {
  id: number
  name: string
}

interface LogData {
  id: number
  header: string
  log: string
  notes: string
  log_date: string
  scheduled_date: string | null
  scheduled_notes: string
  log_type_id: number | null
  customer_location_id: number | null
  customer_user_id: number | null
  user_id: number | null
  urgent: boolean
}

interface Props {
  customer: Customer
  log: LogData
  log_types: Option[]
  locations: Option[]
  contacts: Option[]
  users: Option[]
  errors?: Record<string, string[]>
}

export default function Edit({
  customer,
  log,
  log_types,
  locations,
  contacts,
  users,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Customers", href: "/customers" },
    { title: customer.display_name, href: `/customers/${customer.id}` },
    { title: "Logs", href: `/customers/${customer.id}/logs` },
    { title: "Edit", href: `/customers/${customer.id}/logs/${log.id}/edit` },
  ]

  const { data, setData, patch, processing, transform } = useForm({
    header: log.header || "",
    log: log.log || "",
    notes: log.notes || "",
    log_date: log.log_date || "",
    scheduled_date: log.scheduled_date,
    scheduled_notes: log.scheduled_notes || "",
    log_type_id: log.log_type_id,
    customer_location_id: log.customer_location_id,
    customer_user_id: log.customer_user_id,
    user_id: log.user_id,
    urgent: log.urgent,
  })

  transform((data) => ({ log: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/customers/${customer.id}/logs/${log.id}`)
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit Log - ${customer.display_name}`} />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Edit Log</h1>

        <LogForm
          customerId={customer.id}
          data={data}
          setData={setData}
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Update Log"
          log_types={log_types}
          locations={locations}
          contacts={contacts}
          users={users}
        />
      </div>
    </AppLayout>
  )
}
